import React from 'react';
import './Privacy.css';

function Privacy({ onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="page-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h1>Privacy Policy</h1>
        
        <div className="page-content">
          <section>
            <h2>Data Protection</h2>
            <p>
              We take your privacy and security seriously. This platform is designed to protect your anonymity 
              and personal information.
            </p>
          </section>

          <section>
            <h2>Email Encryption</h2>
            <p>
              Your email address is encrypted using industry-standard encryption before being stored in our database. 
              This ensures that even in the event of a data breach, your email address remains protected and cannot 
              be read without the encryption key.
            </p>
          </section>

          <section>
            <h2>Account Information</h2>
            <p>
              We collect minimal information necessary for account functionality:
            </p>
            <ul>
              <li><strong>Display Name:</strong> Publicly visible name you choose</li>
              <li><strong>Email Address:</strong> Encrypted and used only for account verification and important communications</li>
              <li><strong>Bio & Location:</strong> Optional information you choose to share</li>
            </ul>
          </section>

          <section>
            <h2>Post and Comment Data</h2>
            <p>
              Your posts and comments are associated with your display name only. We do not 
              share your email address or other personal information with other users.
            </p>
          </section>

          <section>
            <h2>Security Measures</h2>
            <p>
              We implement multiple layers of security to protect your data:
            </p>
            <ul>
              <li>All passwords are hashed using bcrypt before storage</li>
              <li>Email addresses are encrypted at rest</li>
              <li>HTTPS encryption for all data transmission</li>
              <li>Rate limiting to prevent abuse and attacks</li>
              <li>Content moderation to maintain a safe environment</li>
              <li>Account freezing system for reported content</li>
            </ul>
          </section>

          <section>
            <h2>Data Retention</h2>
            <p>
              Your account data is retained as long as your account is active. You may delete your account 
              at any time, which will permanently remove all associated data including posts and comments.
            </p>
          </section>

          <section>
            <h2>Third-Party Services</h2>
            <p>
              We use Resend for email delivery. Email addresses are shared with Resend only for the purpose 
              of sending verification and notification emails. Resend's privacy policy applies to their 
              handling of this data.
            </p>
          </section>

          <section>
            <h2>Your Rights</h2>
            <p>
              You have the right to:
            </p>
            <ul>
              <li>Access your personal data</li>
              <li>Update or correct your information</li>
              <li>Delete your account and all associated data</li>
              <li>Request information about data we hold about you</li>
            </ul>
          </section>

          <section>
            <h2>Community Standards</h2>
            <p>
              In addition to this privacy policy, please review our <strong>Community Guidelines</strong> for
              information about acceptable use, prohibited content, and moderation policies. The guidelines
              outline our expectations for respectful and safe participation in the community.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              If you have questions about this privacy policy or how we handle your data, please contact
              the administrator here: <a href="mailto:gcwomensite@gmail.com" className="contact-email">gcwomensite@gmail.com</a>
            </p>
          </section>

          <section>
            <p className="last-updated">
              <em>Last updated: {new Date().toLocaleDateString()}</em>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;

